module.exports = __webpack_public_path__ + "components/flag/static/square/se-86d883e0916174bcd4dc650cb94cecd6.svg";